/*
 * Переключатель режима публикаций. Формы такого органа в base.css нет — это первый
 * тумблер в интерфейсе, и заводить его глобальным классом ради одного места значит
 * предлагать всем остальным переключать им что попало.
 *
 * Размер выбран крупнее обычного тумблера (дорожка 48×26 при высоте шапки 56) осознанно:
 * это не настройка, а рубильник канала, и он обязан быть заметен боковым зрением.
 */

.wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: none;
}

.sw {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: none;
  border: none;
  padding: 4px 6px;
  border-radius: var(--r-pill);
  font-family: var(--sans);
  cursor: pointer;
}
.sw:hover {
  background: var(--bg-alt);
}
/* Индикатор без права переключать: вид тот же, курсор обычный — «смотреть можно». */
.sw:disabled {
  cursor: default;
}
.sw:disabled:hover {
  background: none;
}

.track {
  position: relative;
  width: 48px;
  height: 26px;
  border-radius: var(--r-pill);
  flex: none;
  transition: background-color 0.18s var(--ease);
}

.knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /* Ручка лежит на заливке акцента (боевой) или красного (тестовый) — это белый поверх
     цвета, а не поверхность: в тёмной теме `--white` почти чёрный. Не `--on-accent`: подписи на
     оранжевом у strategai чёрные (мелкий текст), а ручка — графика и остаётся белой. */
  background: var(--knob);
  box-shadow: var(--sh-knob);
  transition: transform 0.18s var(--ease);
}

.label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

/* Боевой — фирменный фиолетовый, ручка справа: включено. */
.live .track {
  background: var(--violet);
}
.live .knob {
  transform: translateX(22px);
}
.live .label {
  color: var(--accent-ink);
}

/* Тестовый — красный, ручка слева: выключено. Красный здесь не «ошибка», а «канал молчит». */
.test .track {
  background: var(--red);
}
.test .label {
  color: var(--red-ink);
}

/* Состояние не загрузилось: серо и без слова — никакого утверждения о режиме. */
.unknown .track {
  background: var(--neutral-bg);
  border: 1px solid var(--border);
}
.unknown .label {
  color: var(--muted);
}

/*
 * Телефон (640): уходит СЛОВО режима, дорожка остаётся. Это последний шаг лестницы подписей
 * шапки и самый дорогой из возможных — «Живой»/«Тест» при 13px/600 стоит ~47px, а на 390px
 * шапка вместе с идущим прогоном в неё уже не помещается, и «не помещается» здесь означает
 * не полосу прокрутки, а отрезанный орган (`overflow-x: clip` у body).
 *
 * Режим при этом НЕ становится невидимым, и это условие правки: дорожка несёт его цветом и
 * положением ручки (фиолетовая справа — живой, красная слева — остановлен), нижняя граница
 * шапки на паузе красная, а слово остаётся в `aria-label`, во всплывающей подсказке и в DOM
 * (гасится стилем, не удаляется). Крупный размер дорожки — 48×26 — выбран как раз ради того,
 * чтобы её было видно боковым зрением без подписи.
 */
@media (max-width: 640px) {
  .label {
    display: none;
  }
  .sw {
    gap: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .track,
  .knob {
    transition: none;
  }
}

/*
 * Подсказка при наведении. Раскрывается и по фокусу с клавиатуры (:focus-within) — иначе
 * «кто и зачем выключил публикации» доступно только мышью.
 *
 * Прижата правым краем к переключателю и ограничена по ширине: она висит в шапке над
 * содержимым страницы, и уехавший вправо блок дал бы горизонтальный скролл — ровно то,
 * чего в этом интерфейсе быть не должно.
 */
.tip {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 300px;
  max-width: 78vw;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: var(--r-ctl);
  background: var(--white);
  border: 1px solid var(--border);
  box-shadow: var(--sh-float);
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--ink-2);
  text-align: left;
  /*
   * Скрыто прозрачностью, а НЕ `visibility: hidden`: подсказка связана с переключателем
   * через `aria-describedby`, и скрытый по visibility блок выпадает из дерева доступности —
   * то есть «кто и зачем выключил публикации» переставало бы существовать для клавиатуры и
   * скринридера, оставаясь доступным только мыши.
   */
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s var(--ease);
}
.tip b {
  font-size: 13px;
  color: var(--ink);
}
.tipNote {
  color: var(--muted);
}

.wrap:hover .tip,
.wrap:focus-within .tip {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .tip {
    transition: none;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
